const MultiProductSelectType = {
  SET_ALL_PRODUCT_DETAILS: 'SET_ALL_PRODUCT_DETAILS',
  // SET_ALL_PRODUCT_COLOURWAYS: "SET_ALL_PRODUCT_COLOURWAYS",
  // SET_ALL_PRODUCT_SIZES: "SET_ALL_PRODUCT_SIZES",
  // SET_ALL_PRODUCT_LENGTHS: "SET_ALL_PRODUCT_LENGTHS",
  SET_ALL_PRODUCT_TESTING_LIBS: 'SET_ALL_PRODUCT_TESTING_LIBS',
  SET_ALL_PRODUCT_BOM_COMPS: 'SET_ALL_PRODUCT_BOM_COMPS',
  SET_ALL_EXCHANGE_RATES: 'SET_ALL_EXCHANGE_RATES',
  SET_CURRENT_PRODUCT_DATA: 'SET_CURRENT_PRODUCT_DATA',
  SET_FIRST_SELECTION_DATA: 'SET_FIRST_SELECTION_DATA',
  CLEAR_REDUCER_MULTIPLE_COSTING: 'CLEAR_REDUCER_MULTIPLE_COSTING',
};

export default MultiProductSelectType;
